export class ExtendedMap extends Map {
    constructor() {
        super();
    }
    find(fn:any) {
        for (const [k, v] of this.entries()) {
            if(fn(v)) return v;
        }
        return undefined;
    }
    filter(fn:any) {
        const res = [];
        for (const [k, v] of this.entries()) {
            if(fn(v)) res.push(v);
        }
        return res;
    }
    map(fn:any) {
        const res = [];
        for (const [k, v] of this.entries()) {
            res.push(fn(v, k));
        }
        return res;
    }
    reduce(fn:any, first:any) {
        let res = first;
        for (const [k, v] of this.entries()) {
            res = fn(res, [k, v]);
        }
        return res;
    }
  }